<style type="text/css">
    .loadercenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    .overlay {
        position: fixed;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        /* background-color: black; */
        z-index: 99999;
    }
    
    div.item {
        vertical-align: top;
        display: inline-block;
        text-align: center;
        width: 120px;
    }
</style>
<div class="item" *ngIf="isShowLoader">

    <div class="overlay">
        <div class="loadercenter">
            <img src="{{assetURL}}/assets/images/GIF/loading.gif" width="64" height="64" alt="Loading...">
        </div>
    </div>
</div>
<div class="main_content pt-4 container-fluid">
    <section class="all-videos section-divider" *ngIf="AllCardData != null && AllCardData.length > 0">
        <div class="section-title section-title-secondary d-flex justify-content-between align-items-center">
            <h2>{{pageTitle}}</h2>
        </div>
        <div class="card-row">
            <div class="row" *ngIf="AllCardData != null && AllCardData.length > 0">
                <div class="col-sm-6 col-md-4 col-xl-3 col-12 row-seprator" *ngFor="let item of AllCardData">
                    <app-card-post [card]=item></app-card-post>
                </div>
            </div>
        </div>
        <div class="uk-grid loader" *ngIf="isAllVideoLoading">
            <div uk-spinner></div>
            <p>Loading</p>
        </div>
    </section>
    <section class="all-videos section-divider text-center" *ngIf="isShowNoContent">
        <h2>No Content to show.</h2>
    </section>

</div>